import React from 'react'
import styled from 'styled-components'
import { SchoolListRow } from './SchoolListRow'
import { ScrollMoreIndicator } from '../../../components/ScrollList/ScrollMoreIndicator'
import { LatLng } from '../../../types/LatLng.types'
import { School } from '../../props/School.types'

const StyledSchoolList = styled.div`
  ${({ isHorizontal }: { isHorizontal?: boolean }) =>
    isHorizontal
      ? `
    display: flex;
  `
      : `
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  `}
`

interface ISchoolListProps {
  listRef?: object
  coords?: LatLng
  schools: Array<School>
  isOpenInNewTab?: boolean
  isHorizontal?: boolean
  isShowRightScrollMoreIndicator?: boolean
  isShowLeftScrollMoreIndicator?: boolean
  isShowDistance?: boolean
  isShowLevel?: boolean
  isShowSector?: boolean
  isShowGender?: boolean
  isShowSchoolResults?: boolean
  isShowSchoolFees?: boolean
}

const SchoolList: React.FC<ISchoolListProps> = ({
  schools,
  listRef,
  coords,
  isOpenInNewTab,
  isHorizontal = false,
  isShowLeftScrollMoreIndicator = false,
  isShowRightScrollMoreIndicator = false,
  isShowLevel,
  isShowSector,
  isShowGender,
  isShowSchoolResults,
  isShowSchoolFees,
  isShowDistance,
}) => (
  <StyledSchoolList isHorizontal={isHorizontal} ref={listRef}>
    {schools.map((school) => (
      <SchoolListRow
        key={school.id}
        coords={coords}
        school={school}
        isOpenInNewTab={isOpenInNewTab}
        isAlignLogoToRight={isHorizontal}
        isHorizontal={isHorizontal}
        isShowLevel={isShowLevel}
        isShowSector={isShowSector}
        isShowGender={isShowGender}
        isShowSchoolResults={isShowSchoolResults}
        isShowSchoolFees={isShowSchoolFees}
        isShowDistance={isShowDistance}
      />
    ))}
    {isShowLeftScrollMoreIndicator && <ScrollMoreIndicator size=".5rem" />}
    {isShowRightScrollMoreIndicator && (
      <ScrollMoreIndicator size=".5rem" isAlignRight />
    )}
  </StyledSchoolList>
)

export { SchoolList }
